export default __webpack_public_path__ + "static/media/icon-depotLine.f3a9f189.svg";